import { ISelectDgtxKetQuaRequest } from '../models/request/danh-gia/thuong-xuyen/ISelectDgtxKetQuaRequest';
import { IUpdateDgtxKetQuaRequest } from '../models/request/danh-gia/thuong-xuyen/IUpdateDgtxKetQuaRequest';
import { apiClient } from './apiClient';
export const API_APP_DGTX_KETQUA_NLPC_PATH = "dgtx-nlpc"
export const dgtxKetQuaApi = {
    Select: (request: ISelectDgtxKetQuaRequest) => apiClient.post(`${API_APP_DGTX_KETQUA_NLPC_PATH}/select`, request),
    Save: (request: IUpdateDgtxKetQuaRequest) => apiClient.post(`${API_APP_DGTX_KETQUA_NLPC_PATH}/save`, request)
}